module.exports = __webpack_public_path__ + "img/prize3.d3b36cab.png";